module.exports = __webpack_public_path__ + "static/media/icon_add.20721d64.svg";